var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.08931C16.5909 8.26875 16.1551 8.38769 15.7006 8.44544C16.1681 8.16631 16.5249 7.72769 16.6927 7.199C16.2568 7.45887 15.7756 7.64244 15.2627 7.74488C14.8488 7.30419 14.2589 7.03125 13.6154 7.03125C12.3669 7.03125 11.3618 8.04463 11.3618 9.28694C11.3618 9.46569 11.3769 9.63756 11.4141 9.80119C9.53925 9.70975 7.88031 8.81119 6.76587 7.44238C6.57131 7.77994 6.45719 8.16631 6.45719 8.58225C6.45719 9.36325 6.85938 10.0556 7.45887 10.4564C7.09656 10.4495 6.74112 10.3443 6.44 10.1786C6.44 10.1855 6.44 10.1944 6.44 10.2034C6.44 11.2992 7.22169 12.2095 8.24675 12.4192C8.06319 12.4694 7.86312 12.4934 7.6555 12.4934C7.51112 12.4934 7.36537 12.4852 7.22856 12.4549C7.52075 13.348 8.34988 14.0046 9.33575 14.0259C8.5685 14.6261 7.59431 14.9877 6.53969 14.9877C6.35475 14.9877 6.17737 14.9794 6 14.9567C6.99894 15.6009 8.18281 15.9688 9.4595 15.9688C13.6093 15.9688 15.878 12.5312 15.878 9.55163C15.878 9.45194 15.8746 9.35569 15.8698 9.26013C16.3173 8.9425 16.6934 8.54581 17 8.08931Z",
    fill: "#F9F5EE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitter);
export default __webpack_public_path__ + "static/media/social_twitter.3ddf49e9ab34e10e2d8920577f9a85c3.svg";
export { ForwardRef as ReactComponent };